module.exports = require('lodash').noop